export default __webpack_public_path__ + "files/plantilla_tarifario.xlsx";